<template>

  <div class="user">


    <div class="product-content">
      <el-form ref="form" :model="form" label-width="100px">
        <div class="table-wrap">
          <el-table size="small" :data="tableData" border style="width: 100%" v-loading="loading">
            <el-table-column prop="auction_id" label="求购ID"></el-table-column>
            <el-table-column prop="auction_name" label="名称"></el-table-column>
            <el-table-column prop="auction_types" label="类型">
              <template slot-scope="scope">
                <div v-if="scope.row.auction_type==1">
                  <span>生日hhhh纪忆酒</span>
                </div>
                <div v-if="scope.row.auction_type==2">
                  <span>大坛封hhhh藏酒</span>
                </div>
                <div v-if="scope.row.auction_type==3">
                  <span>大师纪hhhh念酒</span>
                </div>
                <div v-if="scope.row.auction_type==4">
                  <span>明星纪hhhh念酒</span>
                </div>

              </template>
            </el-table-column>
            <el-table-column prop="auction_number" label="编码"></el-table-column>
            <el-table-column prop="auction_price" label="求购价格"></el-table-column>
            <el-table-column prop="auction_year" label="年份"></el-table-column>
            <el-table-column prop="create_time" label="发布时间"></el-table-column>
          </el-table>
        </div>
      </el-form>
      <!--分页-->
      <div class="pagination">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" background :current-page="curPage"
                       :page-size="pageSize" layout="total, prev, pager, next, jumper"
                       :total="totalDataNumber">
        </el-pagination>
      </div>
    </div>
  </div>
</template>
<script>
  import AuctionApi from '@/api/auction.js';
  export default {
    data() {
      return {
        formInline: {},
        form: {},
        tableData: [],
        /*一页多少条*/
        pageSize: 20,
        /*一共多少条数据*/
        totalDataNumber: 0,
        /*当前是第几页*/
        curPage: 1,
        /*是否加载完成*/
        loading: true,
      };
    },
    created() {
      /*获取列表*/
      this.getData();
    },
    methods: {
      /*获取列表*/
      getData() {
        let self = this;
        let Params = {};
        Params.page = self.curPage;
        Params.list_rows = self.pageSize;
        AuctionApi.PurchaseList(Params, true)
          .then(data => {
            self.loading = false;
            self.tableData = data.data.list.data;
            self.totalDataNumber = data.data.list.total
          })
          .catch(error => {});
      },
      /*选择第几页*/
      handleCurrentChange(val) {
        let self = this;
        self.curPage = val;
        self.loading = true;
        self.getData();
      },

      /*每页多少条*/
      handleSizeChange(val) {
        this.curPage = 1;
        this.pageSize = val;
        this.getTableList();
      },


    }
  };
</script>

<style>
</style>




// WEBPACK FOOTER //
// src/views/plus/auction/auction/Purchase.vue